import React from 'react';
import { motion } from 'framer-motion';
export function Vision() {
  const scrollToForm = () => {
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const cards = [{
    icon: '💙',
    title: 'Inspiras Sin Saber',
    text: 'Hay una mujer que hoy está dudando. Tu historia puede ser la señal que estaba esperando para actuar. Sin que tú lo sepas, ya eres su heroína.'
  }, {
    icon: '⭐',
    title: 'Validas la Posibilidad',
    text: 'Cuando otra mujer de 40+ te ve a ti transformada, entiende que para ella también es posible. Eso no tiene precio.'
  }, {
    icon: '🌿',
    title: 'Construyes Comunidad',
    text: 'RenuevaTE_90 no es un programa. Es una comunidad de mujeres reales que se sostienen entre sí. Porque Lorena creyó desde el día 1 que solas llegamos más rápido, pero juntas llegamos más lejos.'
  }];
  return <section className="py-24 px-6 bg-pearl-white" data-id="element-277">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-278">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-4 text-center" data-id="element-279">
          Por qué tu historia importa
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-playfair font-bold text-deep-blue text-3xl md:text-[42px] leading-[1.2] text-center mb-6" data-id="element-280">
          Cada Historia Real
          <br data-id="element-281" />
          Vale Más que
          <br data-id="element-282" />
          Mil Palabras Perfectas
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="font-montserrat text-gray-text text-center max-w-[600px] mb-16 leading-relaxed" data-id="element-283">
          En un mundo lleno de promesas vacías, tu experiencia honesta es el
          activo más poderoso que existe. Lorena lo sabe. Por eso lleva 25 años
          construyendo comunidad con historias reales.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mb-16" data-id="element-284">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3 + index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-luxury-card border-t-4 border-champagne-gold flex flex-col items-center text-center" data-id="element-285">
              <span className="text-4xl mb-6" data-id="element-286">{card.icon}</span>
              <h3 className="font-playfair font-bold text-deep-blue text-[22px] mb-4" data-id="element-287">
                {card.title}
              </h3>
              <p className="font-montserrat text-gray-text text-[15px] leading-relaxed" data-id="element-288">
                {card.text}
              </p>
            </motion.div>)}
        </div>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={scrollToForm} initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="border-2 border-champagne-gold text-champagne-gold hover:bg-champagne-gold hover:text-white font-montserrat font-bold text-base py-4 px-8 rounded-full transition-all duration-300" data-id="element-289">
          Quiero Ser Parte de Esta Comunidad
        </motion.button>
      </div>
    </section>;
}